import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

interface Car {
  id: string;
  make: string;
  model: string;
  year: number;
  price: number;
  monthlyPayment: number;
  image: string;
  features: string[];
  mileage: string;
  fuelType: string;
  transmission: string;
}

const Inventory: React.FC = () => {
  const navigate = useNavigate();

  const cars: Car[] = [
    {
      id: '1',
      make: 'Toyota',
      model: 'Camry',
      year: 2023,
      price: 28500,
      monthlyPayment: 485,
      image: 'https://images.unsplash.com/photo-1549317336-206569e8475c?w=800&h=600&fit=crop&auto=format',
      features: ['Bluetooth', 'Backup Camera', 'Lane Assist', 'Cruise Control'],
      mileage: '15,000 km',
      fuelType: 'Hybrid',
      transmission: 'CVT'
    },
    {
      id: '2',
      make: 'Honda',
      model: 'CR-V',
      year: 2023,
      price: 32500,
      monthlyPayment: 550,
      image: 'https://images.unsplash.com/photo-1550355291-bbee04a92027?w=800&h=600&fit=crop&auto=format',
      features: ['AWD', 'Sunroof', 'Heated Seats', 'Apple CarPlay'],
      mileage: '12,000 km',
      fuelType: 'Gas',
      transmission: 'Automatic'
    },
    {
      id: '3',
      make: 'Ford',
      model: 'F-150',
      year: 2022,
      price: 45000,
      monthlyPayment: 765,
      image: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&h=600&fit=crop&auto=format',
      features: ['4WD', 'Towing Package', 'Bed Liner', 'Navigation'],
      mileage: '25,000 km',
      fuelType: 'Gas',
      transmission: 'Automatic'
    },
    {
      id: '4',
      make: 'BMW',
      model: '3 Series',
      year: 2023,
      price: 42000,
      monthlyPayment: 715,
      image: 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=800&h=600&fit=crop&auto=format',
      features: ['Leather Seats', 'Premium Audio', 'Sport Package', 'Heated Steering'],
      mileage: '8,000 km',
      fuelType: 'Gas',
      transmission: 'Automatic'
    },
    {
      id: '5',
      make: 'Nissan',
      model: 'Altima',
      year: 2023,
      price: 26500,
      monthlyPayment: 450,
      image: 'https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=800&h=600&fit=crop&auto=format',
      features: ['ProPILOT Assist', 'Bose Audio', 'Remote Start', 'Wireless Charging'],
      mileage: '18,000 km',
      fuelType: 'Gas',
      transmission: 'CVT'
    },
    {
      id: '6',
      make: 'Chevrolet',
      model: 'Equinox',
      year: 2023,
      price: 29500,
      monthlyPayment: 500,
      image: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800&h=600&fit=crop&auto=format',
      features: ['All-Wheel Drive', 'WiFi Hotspot', 'Teen Driver', 'Safety Package'],
      mileage: '14,000 km',
      fuelType: 'Gas',
      transmission: 'Automatic'
    },
    {
      id: '7',
      make: 'Toyota',
      model: 'RAV4',
      year: 2023,
      price: 34500,
      monthlyPayment: 585,
      image: 'https://images.unsplash.com/photo-1519641471654-76ce0107ad1b?w=800&h=600&fit=crop&auto=format',
      features: ['AWD', 'Hybrid Engine', 'Safety Sense 2.0', 'Wireless Charging'],
      mileage: '10,000 km',
      fuelType: 'Hybrid',
      transmission: 'CVT'
    },
    {
      id: '8',
      make: 'Honda',
      model: 'Civic',
      year: 2023,
      price: 24500,
      monthlyPayment: 415,
      image: 'https://images.unsplash.com/photo-1555215695-3004980ad54e?w=800&h=600&fit=crop&auto=format',
      features: ['Honda Sensing', 'Apple CarPlay', 'Lane Keep Assist', 'Adaptive Cruise'],
      mileage: '16,000 km',
      fuelType: 'Gas',
      transmission: 'CVT'
    },
    {
      id: '9',
      make: 'Audi',
      model: 'A4',
      year: 2022,
      price: 38500,
      monthlyPayment: 655,
      image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=800&h=600&fit=crop&auto=format',
      features: ['Quattro AWD', 'Virtual Cockpit', 'Premium Plus', 'B&O Audio'],
      mileage: '22,000 km',
      fuelType: 'Gas',
      transmission: 'Automatic'
    },
    {
      id: '10',
      make: 'Mercedes-Benz',
      model: 'C-Class',
      year: 2022,
      price: 41500,
      monthlyPayment: 705,
      image: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&h=600&fit=crop&auto=format',
      features: ['MBUX System', 'Leather Seats', 'Panoramic Roof', 'Burmester Audio'],
      mileage: '19,000 km',
      fuelType: 'Gas',
      transmission: 'Automatic'
    },
    {
      id: '11',
      make: 'Subaru',
      model: 'Outback',
      year: 2023,
      price: 31500,
      monthlyPayment: 535,
      image: 'https://images.unsplash.com/photo-1550355291-bbee04a92027?w=800&h=600&fit=crop&auto=format',
      features: ['Symmetrical AWD', 'EyeSight Safety', 'X-Mode', 'Starlink Multimedia'],
      mileage: '13,000 km',
      fuelType: 'Gas',
      transmission: 'CVT'
    },
    {
      id: '12',
      make: 'Mazda',
      model: 'CX-5',
      year: 2023,
      price: 30500,
      monthlyPayment: 520,
      image: 'https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=800&h=600&fit=crop&auto=format',
      features: ['i-Activsense', 'Bose Audio', 'Heated Seats', 'Mazda Connect'],
      mileage: '11,000 km',
      fuelType: 'Gas',
      transmission: 'Automatic'
    },
    {
      id: '13',
      make: 'Volkswagen',
      model: 'Jetta',
      year: 2023,
      price: 25500,
      monthlyPayment: 435,
      image: 'https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=800&h=600&fit=crop&auto=format',
      features: ['Car-Net', 'Beats Audio', 'Driver Assistance', 'Digital Cockpit'],
      mileage: '17,000 km',
      fuelType: 'Gas',
      transmission: 'Automatic'
    },
    {
      id: '14',
      make: 'Hyundai',
      model: 'Tucson',
      year: 2023,
      price: 29500,
      monthlyPayment: 500,
      image: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800&h=600&fit=crop&auto=format',
      features: ['SmartSense', 'Wireless Charging', 'Panoramic Sunroof', 'Blue Link'],
      mileage: '14,000 km',
      fuelType: 'Gas',
      transmission: 'Automatic'
    },
    {
      id: '15',
      make: 'Kia',
      model: 'Sorento',
      year: 2022,
      price: 33500,
      monthlyPayment: 570,
      image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=800&h=600&fit=crop&auto=format',
      features: ['UVO Link', '3rd Row Seating', 'AWD', 'Premium Audio'],
      mileage: '20,000 km',
      fuelType: 'Gas',
      transmission: 'Automatic'
    }
  ];

  const handleCarSelect = (car: Car) => {
    // Navigate to home page with application pre-filled
    navigate('/', { 
      state: { 
        prefillData: {
          vehicleType: getVehicleTypeFromCar(car),
          monthlyBudget: getBudgetFromPrice(car.monthlyPayment)
        }
      } 
    });
  };

  const getVehicleTypeFromCar = (car: Car): string => {
    if (car.model.includes('F-150') || car.make === 'Ford') return 'truck';
    if (car.model.includes('CR-V') || car.model.includes('Equinox')) return 'suv';
    if (car.model.includes('3 Series') || car.make === 'BMW') return 'coupe';
    return 'sedan';
  };

  const getBudgetFromPrice = (monthlyPayment: number): string => {
    if (monthlyPayment < 500) return 'under-500';
    if (monthlyPayment < 750) return '500-750';
    if (monthlyPayment < 1000) return '750-1000';
    return '1000-plus';
  };

  const formatPrice = (price: number): string => {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: 'CAD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onGetStarted={() => navigate('/')} />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Our Vehicle Inventory
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Browse our carefully selected pre-owned vehicles. All cars come with our comprehensive warranty and financing options.
          </p>
        </div>


        {/* Vehicle Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cars.map((car) => (
            <div
              key={car.id}
              className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden cursor-pointer group"
              onClick={() => handleCarSelect(car)}
            >
              {/* Car Image */}
              <div className="h-48 bg-gray-200 overflow-hidden">
                <img 
                  src={car.image} 
                  alt={`${car.year} ${car.make} ${car.model}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
              </div>

              {/* Car Details */}
              <div className="p-6">
                <div className="flex justify-between items-start mb-3">
                  <div>
                    <h3 className="text-xl font-bold text-gray-900">
                      {car.year} {car.make} {car.model}
                    </h3>
                    <p className="text-gray-600 text-sm">
                      {car.mileage} • {car.fuelType} • {car.transmission}
                    </p>
                  </div>
                </div>

                {/* Pricing */}
                <div className="mb-4">
                  <div className="text-2xl font-bold text-blue-600">
                    {formatPrice(car.price)}
                  </div>
                  <div className="text-sm text-gray-600">
                    Starting at {formatPrice(car.monthlyPayment)}/month*
                  </div>
                </div>

                {/* Features */}
                <div className="mb-4">
                  <div className="text-sm font-medium text-gray-700 mb-2">Key Features:</div>
                  <div className="flex flex-wrap gap-1">
                    {car.features.slice(0, 3).map((feature, index) => (
                      <span
                        key={index}
                        className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full"
                      >
                        {feature}
                      </span>
                    ))}
                    {car.features.length > 3 && (
                      <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full">
                        +{car.features.length - 3} more
                      </span>
                    )}
                  </div>
                </div>

                {/* CTA Button */}
                <button className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200 group-hover:bg-blue-700">
                  Apply for Financing
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Cash Back Promo Banner - LARGE */}
        <div className="mt-16 mb-12">
          <div className="bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-400 border-4 border-yellow-300 rounded-3xl p-12 text-center shadow-2xl transform hover:scale-105 transition-transform">
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-6 sm:space-y-0 sm:space-x-8 mb-4">
              <div className="text-9xl sm:text-[12rem] font-black text-blue-900 leading-none">$500</div>
              <div className="text-center sm:text-left">
                <div className="font-black text-blue-900 text-6xl sm:text-7xl mb-3">CASH BACK!</div>
                <div className="font-bold text-blue-800 text-3xl sm:text-4xl mb-3">Get $500 CAD cash when you purchase a car from us!</div>
                <div className="font-semibold text-blue-700 text-xl sm:text-2xl">Limited Time Offer - Don't Miss Out!</div>
              </div>
            </div>
            <p className="text-blue-900 text-lg sm:text-xl mt-4 font-semibold">*Terms and conditions apply. Offer valid for purchases from our inventory.</p>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-8 text-center">
          <div className="bg-blue-600 rounded-2xl p-8 text-white">
            <h2 className="text-3xl font-bold mb-4">
              Don't See What You're Looking For?
            </h2>
            <p className="text-xl mb-6 text-blue-100">
              We're constantly updating our inventory. Get pre-approved and we'll help you find the perfect vehicle.
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-white text-blue-600 px-8 py-3 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors duration-200"
            >
              Get Pre-Approved Now
            </button>
          </div>
        </div>
      </main>

      <Footer />
      
    </div>
  );
};

export default Inventory;
